import script from "./AddEstablishmentModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddEstablishmentModal.vue?vue&type=script&lang=ts&setup=true"

import "./AddEstablishmentModal.vue?vue&type=style&index=0&id=2c4b923c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c4b923c"]])

export default __exports__